export default "__VITE_ASSET__fcaa2594__"